// Sections
function isNearTop(element, offset = 200) {
    var rect = element.getBoundingClientRect();
    return rect.top <= (window.innerHeight || document.documentElement.clientHeight) - offset;
}

function handleLayoutItems() {
    var layoutItems = document.querySelectorAll('.umb-block-grid__layout-item');
    if (layoutItems) {
        layoutItems.forEach(function (el) {
            if (isNearTop(el, 200)) {
                el.classList.add('section--visible');
            }
        });
    }
}

window.addEventListener("scroll", handleLayoutItems);
window.addEventListener("load", handleLayoutItems);